"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TipBox;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const merge_1 = require("merge");
const TipCloseIcon_1 = require("../../../assets/icons/TipCloseIcon");
const TipCloseBlackIcon_1 = require("../../../assets/icons/TipCloseBlackIcon");
const index_style_1 = require("./index.style");
function TipBox({ children, selected, onClick, blackThemeStyle, sx, closeIcon, id, insideTipV2 = false, shouldStretchBoxes = false, }) {
    const styles = (0, index_style_1.default)({ selected, blackThemeStyle, insideTipV2, shouldStretchBoxes });
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: (0, merge_1.merge)(true, styles.container, sx), onClick: onClick, id: id, children: [closeIcon &&
                selected &&
                (blackThemeStyle ? ((0, jsx_runtime_1.jsx)(TipCloseBlackIcon_1.default, { sx: styles.closeIcon, inheritViewBox: true })) : ((0, jsx_runtime_1.jsx)(TipCloseIcon_1.default, { sx: styles.closeIcon, inheritViewBox: true }))), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: styles.contents, children: children })] }));
}
